import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    baseUrl: String,
    start: String,
    end: String
  }

  change(event) {
    const id = event.target.value;
    let url = this.baseUrlValue;

    // Construct the URL logic
    const params = new URLSearchParams();
    if (id) params.set('district_id', id);
    if (this.startValue) params.set('start', this.startValue);
    if (this.endValue) params.set('end', this.endValue);

    const finalUrl = `${url.split('?')[0]}?${params.toString()}`;

    // This keeps the page transition smooth and doesn't "hard reload"
    Turbo.visit(finalUrl);
  }
}
